<ng-container *ngIf="previewData">
    <div class="d-flex justify-content-between p-2" *ngIf="extracts?.length > 0">
        <button class="btn btn-light" (click)="previousExtract()" [disabled]="currentIndex < 1">
            <i class="fas fa-arrow-left"></i>&nbsp;{{ 'msg#preview.previousDocument' | sqMessage}}
        </button>
        <div class="btn-group" [sq-action-buttons]="{items: [sortAction], autoAdjust: true}" ></div>
        <button class="btn btn-light float-right" (click)="nextExtract()" [disabled]="currentIndex >= extracts.length-1">
            {{ 'msg#preview.nextDocument' | sqMessage}}&nbsp;<i class="fas fa-arrow-right"></i>
        </button>
    </div>

    <div *ngIf="loading" class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-grow" role="status"></div>
    </div>
    <div class="text-center text-muted" *ngIf="!loading && extracts?.length === 0; else extractsTpl">
        <span>{{ 'msg#preview.noextract' | sqMessage}}</span>
    </div>
    
    <ng-template #extractsTpl>
        <cdk-virtual-scroll-viewport #scrollViewport [itemSize]="64" class="h-100">
            <div *cdkVirtualFor="let extract of extracts; let i = index" class="ps-2 pe-2">
                <a  href="#" 
                    class="card my-1 list-group-item-action"
                    [ngClass]="{'active': i === currentIndex}"
                    (click)="scrollExtract(extract, i)">
                    <p class="card-body m-0" [innerHTML]="extract.text"></p>
                </a>
            </div>
        </cdk-virtual-scroll-viewport>
    </ng-template>
</ng-container>

<div class="text-center" *ngIf="!previewData">
    {{ 'msg#preview.loading' | sqMessage}}
</div>